import React, { Component } from 'react';
import { ActionPanel, GenericViewer, ProductCode, ProductDescription, ProductImage, ProductPrice, SvgImage } from '../../../../components';
import { translate } from '../../../../services';
import { PricingModule, isContained } from '../../../../util';
import { connect } from 'react-redux';
import { productState, priceState,productsDispatcher,identityState,combineStates, siteSettingsState, screenSizeState } from '../../../../store';
import { EmptyStateIconNew, GreyFilterEmptyIconNew, TrashIconNew, resetIcon } from '../../../../../style/images';
import { PropTypes } from 'prop-types';
import { BreadcrumbHeader } from '../../navigation';
import { Box } from '@mui/material';
import { BomItem } from '../model';

export class AccessoriesCartComponent extends Component {
  constructor( props ) {
    super( props );
    this.loadingStatus = {};
  }

  componentDidMount() {
    this.updateFromProps( this.props );
  }

  componentDidUpdate() {
    this.updateFromProps( this.props );
  }

  updateFromProps( nextProps ) {
    const { accessories, products, prices } = nextProps;

    for( let accessory of accessories ) {
      const code = accessory && accessory.assignedValue.name;
      //To verify if the additional condition is required to handle accessories
      if (!code && Object.keys(products).indexOf(code) !== -1) {
        continue;
      }
      if ( products[code] === undefined && !this.loadingStatus[code] ) {
        this.loadingStatus[code] = true;    
        const oldCustomerCode=sessionStorage.getItem("oldCustomeCode");
        const newCustomerCode=sessionStorage.getItem("customercode");
        if(oldCustomerCode !== newCustomerCode ){
        let pricesData = Object.keys(prices);
        pricesData.forEach(key=>{
          if(key == code)
          {
            delete prices[key];
          }
        })
      }
        this.props.getProduct( code ).then( () => this.loadingStatus[code] = false );
      }
    }
  }

  getLayout = item => {
    const { isPopup, validityInfo, products, wiringDiagramDetails } = this.props;  
    if( !isPopup ) {
      return 'simple';
    }
    //****************************//
    //This is to handle the Wiring Diagram products to be shown in the AccessoriesCart page 
    //without the message of country availablility
    if(!item.name && !item._accessory.assignedValue.fullyQualifiedName ){
     if(wiringDiagramDetails.some(filterdata  => filterdata.component == item._accessory.assignedValue.name))
      return 'wiringdiagram';
    }
      //****************************//
    if( item === null || !item.name || item.obsolete ) {
      return 'unavailable';
    }
    if( validityInfo && isContained( validityInfo.invalidVariables, item._accessory ) ) {
      return 'invalid';
    }
    return item._accessory.isDefault && !item._accessory.isUserAssignment && item._accessory.assignedValue.state === 2 ? 'linked' : false;
  }

  reset = () => this.props.resetConfigurator()

  render() {
    const { accessories, isPopup, products, allMandatorySelectionsMade,wiringDiagramDetails, siteSettings, accessoriesFromAdditionalProducts, configuration,NSTbom_ACC, fromSearch } = this.props;

    return <div className="accessories-cart" style={{height:configuration.length<2 && accessories.length===0&&"100%"}}>
      <div className="accessories-cart-header">
      {!this.props.extraAccessories&&<BreadcrumbHeader 
                  isIntegrated={ siteSettings.isIntegrated } 
                  pathname={ document.location.hash }
                />}
        {!this.props.extraAccessories&&configuration.length===2?
        <div className='header-2'>
          <span>
          {/* { translate( 'Selected Accessories: {amount}', { amount: accessories.length || 0 } ) } */}
          { `${translate("Selected Accessories:")} - ${this.props.configuration[0].product.name}: ${accessories.length || 0}`}
            <SvgImage source={ resetIcon } className="reset-icon" onClick={ this.reset } toolTip={ translate( 'Reset all' ) } />
          </span>
          <Box sx={{flexGrow:1}}></Box>
          {PricingModule.showPrice( siteSettings.pricingModule ) && <div className='products-price'>
            {/* <span>{`${translate("Total Price")}: `}</span> */}
            <ProductPrice translationPhrase={'pricing including tax'} showConfiguratorButtonAtTop={this.props.showConfiguratorButtonAtTop} fromConfigFooter fromCart={ this.props.fromCart } priceSize='big' product={this.props.product } fromSearch={fromSearch}/>
          </div>}
        </div>:
        <>{!this.props.extraAccessories&&accessories.length!==0? <div className='header-2'>
          <span>
          {/* { translate( 'Selected Accessories: {amount}', { amount: accessories.length || 0 } ) } */}
          { `${translate("Selected Accessories:")} - ${this.props.configuration[0].product.name}: ${accessories.length || 0}`}
            <SvgImage source={ resetIcon } className="reset-icon" onClick={ this.reset } toolTip={ translate( 'Reset all' ) } />
          </span>
          <Box sx={{flexGrow:1}}></Box>
          {PricingModule.showPrice( siteSettings.pricingModule ) && <div className='products-price'>
            {/* <span>{`${translate("Total Price")}: `}</span> */}
            <ProductPrice translationPhrase={'pricing including tax'} showConfiguratorButtonAtTop={this.props.showConfiguratorButtonAtTop} fromConfigFooter fromCart={ this.props.fromCart } priceSize='big' product={this.props.product } fromSearch={fromSearch}/>
          </div>}</div>:<></>}</>}
        {
          this.props.extraAccessories&&<div className='header-2'>
          <span>
          {/* { translate( `Selected Accessories: - ${this.props.configuration[0].product.code}: {amount}`, { amount: accessories.length || 0 } ) } */}
          { `${translate("Selected Accessories:")} - ${this.props.configuration[1].product.name}: ${accessories.length || 0}`}
            <SvgImage source={ resetIcon } className="reset-icon" onClick={ this.reset } toolTip={ translate( 'Reset all' ) } />
          </span>
          <Box sx={{flexGrow:1}}></Box>
          {/* <div className='products-price'>
            <span>{`${translate("Total Price")}: `}</span>
            <ProductPrice translationPhrase={'Total_'} showConfiguratorButtonAtTop={this.props.showConfiguratorButtonAtTop} fromConfigFooter fromCart = {this.props.fromCart} priceSize='big' product={this.props.product } />
          </div> */}
          
        </div>
        }
      </div>
      {configuration.length!=2 && accessories.length===0 && !this.props.extraAccessories?
       <div className='no-accessories'>
          <div className='message-container'>
            <div className='empty-icon'>
              <Box component="img" src={GreyFilterEmptyIconNew}></Box>
            </div>
            <div className='message'>
              <span>{translate("Use dropdowns or search bar on the left to select the accessories you need.")}</span>
            </div>
          </div>
      </div>:
      <div className='accessories-list'>
        <Box height={configuration.length==2&&accessoriesFromAdditionalProducts?"max-content":"100%"} width="100%" sx={{overflowY:"auto"}}>
        {configuration.length==2&&accessories?.length==0? <div className='no-accessories' style={{height:configuration.length==2&&accessoriesFromAdditionalProducts?"max-content":"100%", background: "#F5F5F5"}}>
          <div className='message-container'>
            <div className='empty-icon'>
              <Box component="img" src={GreyFilterEmptyIconNew}></Box>
            </div>
            <div className='message'>
              <span>{translate("Use dropdowns or search bar on the left to select the accessories you need.")}</span>
            </div>
          </div>
      </div>:accessories?.length>0&&
        <GenericViewer
	NSTbom_ACC={NSTbom_ACC}
          view={ this.props.view? this.props.view : isPopup ? 'accessory' : 'looseaccessories' }
          useCustomLayout={ this.getLayout }
          className={this.props.screenSize.width<=900&&this.props.fromModelConfiguratorSelector?"mobile-list-view":this.props.screenSize.width<=900&&"mobile-grid-view"}  
          items={ accessories.map( accessory => {
            const code = accessory.assignedValue.name;
            return products[code] !== undefined && ( allMandatorySelectionsMade && products[code] === null || products[code] !== null ) &&Object.assign( {}, products[code], { ['_accessory']: accessory } );
          } ).filter( accessory => accessory ) }
          fromModelConfiguratorSelector = {this.props.screenSize.width<=900&&this.props.fromModelConfiguratorSelector}
          template = {this.props.screenSize.width<=900&&this.props.fromModelConfiguratorSelector&&BomItem}
        />}
        {configuration.length>1 && !configuration[1].materialKey.includes("ACC") && accessoriesFromAdditionalProducts &&<div style={{margin:"16px 0px"}}>
            <div className='header-2' style={{padding:"16px",marginTop:"16px"}}>
                <span>
                {/* { translate( `Selected Accessories: - ${this.props.configuration[1].product.code}: {amount}`, { amount: accessoriesFromAdditionalProducts.length || 0 } ) } */}
                { `${translate("Selected Accessories:")} - ${this.props.configuration[1].product.name}: ${accessoriesFromAdditionalProducts.length || 0}`}  
                  <SvgImage source={ resetIcon } className="reset-icon" onClick={ this.reset } toolTip={ translate( 'Reset all' ) } />
                </span>
                <Box sx={{flexGrow:1}}></Box>
                {PricingModule.showPrice( siteSettings.pricingModule ) && <div className='products-price'>
                  {/* <span>{`${translate("Total Price")}: `}</span> */}
                  <ProductPrice translationPhrase={'pricing including tax'} showConfiguratorButtonAtTop={this.props.showConfiguratorButtonAtTop} fromConfigFooter fromCart={ this.props.fromCart } priceSize='big' product={this.props.product } fromSearch={fromSearch}/>
                </div>}
                
        </div>
        {
          accessoriesFromAdditionalProducts?.length>0 ?
          <GenericViewer
	  NSTbom_ACC={NSTbom_ACC}
          view={ isPopup ? 'accessory' : 'looseaccessories' }
          useCustomLayout={ this.getLayout }
          className={this.props.screenSize.width<=900&&"mobile-grid-view"}  
          items={ accessoriesFromAdditionalProducts.map( accessory => {
            const code = accessory.assignedValue.name;
            return products[code] !== undefined && ( allMandatorySelectionsMade && products[code] === null || products[code] !== null ) &&Object.assign( {}, products[code], { ['_accessory']: accessory } );
          } ).filter( accessory => accessory ) }
        />:<div className='no-accessories' style={{ background: "#F5F5F5"}}>
        <div className='message-container'>
          <div className='empty-icon'>
            <Box component="img" src={GreyFilterEmptyIconNew}></Box>
          </div>
          <div className='message'>
            <span>{translate("Use dropdowns or search bar on the left to select the accessories you need.")}</span>
          </div>
        </div>
    </div>
        }
       </div>}</Box>
      </div>} 
    </div>;
  }
}

AccessoriesCartComponent.propTypes = {
  accessories: PropTypes.arrayOf( PropTypes.shape( {
    assignedValue: PropTypes.shape( { 
      name: PropTypes.string.isRequired 
    } )
  } ) ),
  getProduct: PropTypes.func.isRequired,
  isPopup: PropTypes.bool, 
  language: PropTypes.string.isRequired, 
  onAmountChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  products: PropTypes.shape( {} ),
  resetConfigurator: PropTypes.func.isRequired,
  validityInfo: PropTypes.shape( {
    invalidVariables: PropTypes.array
  } )
};

export const AccessoriesCart = connect( combineStates( productState,priceState,identityState, siteSettingsState, screenSizeState ),productsDispatcher)( AccessoriesCartComponent );